import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Contact } from '@shared/models/data-model';
import { RegistrationService } from '@shared/services/registration.service';

export const contactsResolver: ResolveFn<Contact[]> = (route, state) => {
    return inject(RegistrationService).getAllContacts();
};
